import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core';
import moment from 'moment';

import TableCustom from '../../../../../../Components/Table';

import { useStyles } from '../styles';
import { formataNit } from '../../../../../../Utils/utils';

export default function FichaNovoDocumento({ dadosEspelho }) {

    const classes = useStyles();
    const [data, setData] = useState([]);

    useEffect(() => {
        setData([{
            dataTransmissao: dadosEspelho.dataTransmissao,
            contribuinte: dadosEspelho.contribuinte,
            tipoDocumento: dadosEspelho.tipoDocumento,
            tipoCredito: dadosEspelho.tipoCredito,
            cpf: dadosEspelho.dadosSegurado ? dadosEspelho.dadosSegurado.cpf.valor : null,
            nit: dadosEspelho.dadosSegurado ? dadosEspelho.dadosSegurado.nit : null,
            competencia: dadosEspelho.competencia
        }]);
    }, [dadosEspelho])

    const columns = [
        {
            title: "Data de criação",
            dataIndex: "dataTransmissao",
            key: "dataTransmissao",
            align: "left",
            width: 40,
            headerRender: (title) => <div style={{ paddingLeft: 12, display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13, paddingLeft: 15 }}>{moment(value).format('DD/MM/YYYY')}</p>,
        },
        {
            title: "Contribuinte",
            dataIndex: "contribuinte",
            key: "contribuinte",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "CNPJ/CPF",
            dataIndex: "cpf",
            key: "cpf",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "Tipo de Documento",
            dataIndex: "tipoDocumento",
            key: "tipoDocumento",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "Tipo de Crédito",
            dataIndex: "tipoCredito",
            key: "tipoCredito",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
        {
            title: "NIT",
            dataIndex: "nit",
            key: "nit",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value !== '-') ? formataNit(value) : '-'}</p>,
        },
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex', flexDirection: 'column', borderRight: '1px solid lightgray', borderLeft: '1px solid lightgray', marginRight: 8  }}>
                <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 2 }}>
                    <div style={{ width: '40%', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Ano'}</Typography>
                    </div>
                    <div style={{ width: '40%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Mês'}</Typography>
                    </div>
                </div>
            </div>,
            render: (value, row) =>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <div style={{ width: '40%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <p style={{ fontSize: 13 }}>{(value ?? '').split('/')[1]}</p>
                    </div>
                    <div style={{ width: '40%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <p style={{ fontSize: 13 }}>{(value ?? '').split('/')[0]}</p>
                    </div>
                </div>,
        },
    ];

    const propsTable = {
        columns,
        data,
        heightBody: "140px",
        minHeightBody: "90px",
        marginBorder: false,
        usarMarginBottomContainer: true,
        width: '98%',
        hideBorderBottom: true,
        ativarHoverLinha: false,
        elevationPaper: 0,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div>
                            <Typography className={classes.headerTitle}>{'Ficha Novo Documento'}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <>
            <TableCustom {...propsTable} />
        </>
    )
}
